<div class="exception-body error">
    <div class="exception-panel">
        <div class="exception-code">
            <img src="assets/layout/images/exception/500.svg">
        </div>

        <div class="exception-detail">

            <div class="exception-icon">
                <i class="pi pi-times"></i>
            </div>
            <h1>ERROR OCCURED</h1>
            <p>Please contact the system administrator</p>
            <p-button label="GO TO DASHBOARD" [routerLink]="['/']"></p-button>
        </div>
    </div>
</div>
